import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, Alert } from '@paypalcorp/pp-react';
import getContent from 'pp-react-l10n';

const getRecurringInfoContent = getContent('locals')(
  'common/recurring-checkbox'
);

export default function RecurringInfo({ orgName, amount }) {
  return (
    <Alert type="info" className="recurring-info">
      <BodyText>
        {getRecurringInfoContent(
          'rp.helpText1',
          { orgName: orgName, amount: amount },
          { useHTML: true }
        )}
      </BodyText>
    </Alert>
  );
}

RecurringInfo.propTypes = {
  orgName: PropTypes.string,
  amount: PropTypes.string,
};
